/**
 * The running build, for reference on the login page (SC-36402). vite.config.ts
 * defines both values at build time: the release from the repository's VERSION
 * file (bumped by semantic-release on main) and the short commit SHA. Either is
 * `unknown` when the build could not read it.
 */
export const TRELLIS_VERSION: string = __TRELLIS_VERSION__
export const TRELLIS_COMMIT: string = __TRELLIS_COMMIT__

/** One line, for example `Trellis 1.1.2 (abc1234)`. */
export function buildLabel(version: string = TRELLIS_VERSION, commit: string = TRELLIS_COMMIT): string {
  return `Trellis ${version} (${commit})`
}
